// 获取未来日期和星期几 格式如[{date:'8月3号',week:'星期四'},{date:'8月5号',week:'星期五'}]
//settings 推后一天  numDays获取几天
import config from '@/config';
import { api as viewerApi } from 'v-viewer';
import { Message, MessageBox } from 'element-ui';
import moment from 'moment';
import axios from 'axios';

//获取按钮权限
export const findButtons = (codesToFind) => {
  const buttons = [
    // { code: 'edit', color: '#fa8231', name: '编辑' },
    { code: 'revoke', color: '#fa8231', name: '撤回' },
    { code: 'submit', color: '#fa8231', name: '提交' },
    { code: 'audit', color: ' #E6A23C', name: '受理' },
    { code: 'change', color: '#fa8231', name: '变更' },
    { code: 'back', color: '#165dff', name: '返回' },
    { code: 'unarchive', color: '#67C23A', name: '退回' },
    { code: 'purge', color: '#F56C6C', name: '作废' },
  ];
  return buttons.filter((button) => codesToFind.includes(button.code));
};

// 状态
export const statusIcon = (status) => {
  const statusNum = Number(status)
  switch (statusNum) {
    case 0:
      return require('@/assets/images/status/wtj.png');
    case 1:
      return require('@/assets/images/status/dsl.png');
    case 2:
      return require('@/assets/images/status/ytg.png');
    case 3:
      return require('@/assets/images/status/yth.png');
    default:
      return '';
  }
};

// 获取早中晚
export const setPeriod = () => {
  let hour = moment(new Date()).hour();
  let time = '';
  if (hour < 8) {
    time = '早上好';
  } else if (hour >= 8 && hour < 11) {
    time = '上午好';
  } else if (hour >= 11 && hour < 14) {
    time = '中午好';
  } else if (hour >= 14 && hour < 18) {
    time = '下午好';
  } else {
    time = '晚上好';
  }
  return time;
};

//身份证中间*号表示
export const maskIDCard = (idCard) => {
  if (idCard && idCard.length > 7) {
    let prefix = idCard.substring(0, 3); // 取前3位
    let suffix = idCard.substring(idCard.length - 4); // 取后4位
    let maskedPart = '*'.repeat(idCard.length - 7); // 中间部分用星号代替
    return prefix + maskedPart + suffix;
  } else {
    return idCard; // 如果身份证号码过短，直接返回原字符串
  }
};

//获取地址栏上的参数 返回对象
export const getURLParams = () => {
  let url = window.location.href;
  let params = {};
  let queryString = url.split('?')[1];
  if (queryString) {
    let pairs = queryString.split('&');
    for (let pair of pairs) {
      let [key, value] = pair.split('=');
      params[key] = decodeURIComponent(value);
    }
  }
  return params;
};

// 图片文件下载
export const downloadUrl = async (url, fileName) => {
  try {
    // const fileSuffix = url.split(".").at(-1);
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    // link.setAttribute('download', fileName + '.' + fileSuffix);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {

  }
};
export const getFullUrl = (url) => {
  const reg = new RegExp("http");
  if (reg.test(url)) {
    return url;
  } else {
    return config.baseUrl + url;
  }
}
// 通过文件流格式数据导出excel表格
export const downloadBinaryFile = (url, params, fileName) => {
  MessageBox.confirm('确认导出该列表?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(() => {
      axios
        .post(url, params, { responseType: 'blob' })
        .then((response) => {
          if (response.status === 200) {
            const blobType = 'application/vnd.ms-excel';
            const blobObj = new Blob([response.data], { type: blobType });
            const downloadLink = document.createElement('a');
            let href = window.URL || window.webkitURL || window.moxURL; // 浏览器兼容
            href = href.createObjectURL(blobObj);
            downloadLink.href = href;
            downloadLink.download = `${fileName}.xlsx`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(href);
          }
        })
        .catch((error) => {
          Message.warning(
            error.response.data.message || '文件导出错误，请联系管理员'
          );
        });
    })
    .catch(() => { });
};

// 图片预览
export const showViewImgDialog = (imgSrc) => {
  let images = [{ 'data-source': '' }];
  if (['', null, undefined].includes(imgSrc)) {
    Message.warning('请先选择要查看的图片'); // 这里改成自己的消息弹框提示组件
    return false;
  }
  images[0]['data-source'] = imgSrc;
  viewerApi({
    options: {
      toolbar: true,
      url: 'data-source',
      initialViewIndex: 0,
    },
    images: images,
  });
};

//数组转字符串
export function convertStr(data) {
  Object.keys(data).forEach((key) => {
    if (key !== 'buttons' && data[key]) {
      if (
        Array.isArray(data[key]) &&
        data[key].some((el) => typeof el !== 'object')
      ) {
        data[key] = data[key].join(';');
      }
    }
  });
}

//字符串转数组
export function convertArr(form, groups, cascaderFullPath = true) {
  groups?.forEach((item) => {
    item.fields.forEach((el) => {
      if (el.show && (el.type == 'select-multiple' || (el.type == 'cascader' && cascaderFullPath))) {
        if (form[el.code] && form[el.code].includes(';')) {
          form[el.code] = form[el.code].split(';');
        } else {
          form[el.code] = form[el.code] ? [form[el.code]] : [];
        }
      }
    });
  });
  return form;
}

// 提交校验附件
export const annexVerify = (data) => {
  let arr = [];
  data.map((item) => {
    if (item.required && !item.filePath) {
      arr.push(item.fileType);
    }
  });
  return arr.join(' 、');
};

// 防抖
export function debounce(func, wait = 200) {
  let timeout;
  return function (...args) {
    const context = this;

    if (timeout) {
      this.$message.warning('请勿连续点击！');
      return;
    }

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args); // 执行原函数
      timeout = null;
    }, wait);
  };
}

// 获取单位 亿  万  元
export function getUnit(amount, type) {
  if (typeof amount !== 'number') {
    throw new Error('Amount must be a number.');
  }

  const thresholds = [
    { value: 1e8, label: '亿' },
    { value: 1e4, label: '万' },
    { value: 1, label: '元' },
  ];

  let formattedAmount = amount;
  let unitLabel = '';

  for (let i = 0; i < thresholds.length; i++) {
    if (Math.abs(amount) >= thresholds[i].value) {
      formattedAmount = amount / thresholds[i].value;
      unitLabel = thresholds[i].label;
      break;
    }
  }

  const formatter = new Intl.NumberFormat('zh-CN', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (type === 'num') {
    return `${formatter.format(formattedAmount)}`.trim();
  } else if (type === 'unit') {
    return `${unitLabel}`.trim();
  } else {
    return `${formatter.format(formattedAmount)} ${unitLabel}`.trim();
  }
}

// 时间限制
export function setDisabledDate(time, cur, form) {
  // 开始时间不能大于当前时间
  if (
    (cur.code === 'startTime' || cur.code === 'startYear') &&
    new Date(time).getTime() - new Date().getTime() > 0
  ) {
    Message.warning(`${cur.name}必须小于当前时间`);
    form[cur.code] = '';
    return;
  }
  // 限制开始、结束时间
  if (cur.limit && form[cur.limit]) {
    if (cur.limit === 'startTime') {
      // 当前项时间取值受限于开始时间
      if (new Date(time).getTime() - new Date(form[cur.limit]).getTime() <= 0) {
        Message.warning(`${cur.limitName}必须大于${cur.name}`);
        form[cur.code] = '';
        return;
      }
    } else {
      // 当前项时间取值受限于结束时间
      if (new Date(time).getTime() - new Date(form[cur.limit]).getTime() >= 0) {
        Message.warning(`${cur.limitName}必须大于${cur.name}`);
        form[cur.code] = '';
        return;
      }
    }
  }
}

// 计算两个时间点之间的持续时间
export function parseDateTime(dateTimeStr) {
  const [datePart, timePart] = dateTimeStr.split(' ');
  const [year, month, day] = datePart.split('-').map(Number);
  const [hours, minutes, seconds] = timePart.split(':').map(Number);
  return new Date(year, month - 1, day, hours, minutes, seconds); // 月份从0开始计数
}

export function formatDuration(duration) {
  const days = Math.floor(duration / (1000 * 60 * 60 * 24));
  duration %= 1000 * 60 * 60 * 24;
  const hours = Math.floor(duration / (1000 * 60 * 60));
  duration %= 1000 * 60 * 60;
  const minutes = Math.floor(duration / (1000 * 60));

  // let formattedDuration = '';
  // if (days > 0) {
  //   formattedDuration += `${days}天`;
  // }
  // if (hours > 0 || (days === 0 && minutes > 0)) {
  //   formattedDuration += `${hours}小时`;
  // }
  // // if (minutes > 0) {
  // //   formattedDuration += `${minutes}分`;
  // // }

  return `约${days}天${hours}小时`;
}

export function calculateDuration(dateStr1, dateStr2) {
  let date1 = parseDateTime(dateStr1);
  let date2 = parseDateTime(dateStr2);
  // 确保date1是较早的时间，date2是较晚的时间
  if (date2 < date1) return ''
  if (date1 > date2) {
    [date1, date2] = [date2, date1];
  }
  // 计算持续时间
  const duration = date2.getTime() - date1.getTime();
  // 格式化持续时间
  return formatDuration(duration);
}
// 首字母大写
export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function findFirstChildItem(data) {
  if (!data || data.length === 0) return null;

  const firstItem = data[0];
  if (firstItem.children && firstItem.children.length > 0) {
    return findFirstChildItem(firstItem.children);
  }
  return firstItem;
}
//获取地址栏上的参数 返回对象
export const getURLParameters = () => {
  let url = window.location.href
  let params = {}
  let queryString = url.split('?')[1]
  if (queryString) {
    let pairs = queryString.split('&')
    for (let pair of pairs) {
      let [key, value] = pair.split('=')
      params[key] = decodeURIComponent(value)
    }
  }
  return params
}
export const base64ToHex = (base64) => {
  // 1. 将Base64字符串解码为二进制字符串（每个字符代表一个字节的码点）
  const raw = atob(base64);

  // 2. 创建一个足够长度的Uint8Array（字节数组）来存放结果
  const byteArray = new Uint8Array(raw.length);

  // 3. 将二进制字符串的每个字符的码点存入字节数组
  for (let i = 0; i < raw.length; i++) {
    byteArray[i] = raw.charCodeAt(i);
  }

  // 4. 将字节数组中的每个字节转换为十六进制字符串
  let hex = '';
  for (const byte of byteArray) {
    // `byte`是一个0-255之间的数字
    // 将其转换为16进制，如果结果只有一位，则前面补0
    const hexByte = byte.toString(16).padStart(2, '0');
    hex += hexByte;
  }

  return hex;
}
export const removeEmptyStringFields = (obj) => {
  for (const key in obj) {
    if (obj[key] === "") {
      delete obj[key];
    }
  }
  return obj;
}

// 创建一个全局对象来存储控制器
const downloadControllers = {};

export const downloadUrlWithProgress = async (url, fileName, id, onProgress) => {
  const controller = new AbortController();
  const signal = controller.signal;

  downloadControllers[id] = controller;

  try {
    const response = await fetch(url, { signal });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentLength = response.headers.get('content-length');
    if (!contentLength) {
      throw new Error('无法获取文件大小，无法显示进度。');
    }

    const total = parseInt(contentLength, 10);
    let loaded = 0;

    const reader = response.body.getReader();

    const stream = new ReadableStream({
      async start(controller) {
        try {
          while (true) {
            const { done, value } = await reader.read();

            if (signal.aborted) {
              controller.error(new Error('下载已被取消'));
              break;
            }

            if (done) {
              controller.close();
              break;
            }

            loaded += value.length;
            const progress = Math.round((loaded / total) * 100);
            onProgress({
              loaded,
              total,
              progress
            }, id);

            controller.enqueue(value);
          }
        } catch (error) {
          if (!signal.aborted) {
            controller.error(error);
          }
        }
      },
    });

    const contentType = response.headers.get('content-type') || 'application/octet-stream';

    const responseWithProgress = new Response(stream, {
      headers: {
        'Content-Type': contentType,
        'Content-Length': contentLength
      }
    });

    const blob = await responseWithProgress.blob();

    if (signal.aborted) {
      throw new Error('下载已被取消');
    }

    // 创建正确类型的 Blob
    const downloadBlob = new Blob([blob], { type: contentType });

    // 判断文件名是否已包含后缀
    let downloadFileName = fileName;

    // 检查文件名是否包含文件后缀（包含点号且点号不在开头位置）
    const hasFileExtension = /\.\w+$/.test(fileName);

    if (!hasFileExtension) {
      // 如果没有后缀，从URL中提取后缀并拼接
      const fileSuffix = url.split(".").at(-1);
      if (fileSuffix && fileSuffix.length <= 5) { // 限制后缀长度，避免错误匹配
        downloadFileName = fileName + "." + fileSuffix;
      }
    }

    // 备用方案：如果从URL提取失败，尝试从content-type推断
    if (!hasFileExtension && !url.split(".").at(-1)) {
      const extensionMap = {
        'application/pdf': 'pdf',
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'application/vnd.ms-excel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
        'application/zip': 'zip',
        'application/x-rar-compressed': 'rar',
        'text/plain': 'txt'
      };

      const extension = extensionMap[contentType];
      if (extension) {
        downloadFileName = fileName + "." + extension;
      }
    }

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(downloadBlob);
    link.setAttribute('download', downloadFileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);

    delete downloadControllers[id];

  } catch (error) {
    if (signal.aborted) {
      console.log('下载已取消');
    } else {
      console.error('下载失败:', error);
      throw error;
    }
  } finally {
    delete downloadControllers[id];
  }
};
// 取消下载的函数
export const cancelDownload = (id) => {
  if (downloadControllers[id]) {
    downloadControllers[id].abort();
    delete downloadControllers[id];
    console.log(`下载 ${id} 已取消`);
    return true;
  }
  console.warn(`未找到下载任务 ${id}`);
  return false;
};